{
  "common": {
    "save": "Salvar",
    "saving": "Salvando...",
    "cancel": "Cancelar"
  },
  "header": {
    "title": "Gamificação da área de membros",
    "subtitle": "Configure a gamificação da sua área de membros",
    "tabs": {
      "points": "Pontuação",
      "levels": "Níveis",
      "tasks": "Tarefas"
    }
  },
  "toggle": {
    "label": "Habilitar gamificação",
    "enabled": "Gamificação habilitada!",
    "disabled": "Gamificação desabilitada!",
    "error": "Erro ao atualizar configuração"
  },
  "points": {
    "title": "Configure a pontuação padrão para cada gatilho da gamificação",
    "unit": "Pts.",
    "saveSuccess": "Configurações salvas com sucesso!",
    "saveError": "Erro ao salvar configurações",
    "actions": {
      "lessonCompleted": "Aula concluída",
      "courseStarted": "Curso iniciado",
      "course25Percent": "Curso 25% concluído",
      "course50Percent": "Curso 50% concluído",
      "course75Percent": "Curso 75% concluído",
      "courseCompleted": "Curso concluído",
      "dailyLogin": "Login",
      "lessonFavorited": "Aula favoritada",
      "commentPosted": "Mensagem publicada",
      "certificateEarned": "Certificado emitido",
      "challengeActivityCompleted": "Atividade do desafio concluída",
      "challengeMissionCompleted": "Missão do desafio concluída",
      "challengeCompleted": "Desafio concluído",
      "communityPostCreated": "Missão: criar post",
      "communityCommentCreated": "Missão: fazer comentário",
      "communityPostLiked": "Missão: curtir post"
    }
  },
  "levels": {
    "title": "Configure níveis da sua gamificação",
    "create": "Criar nível",
    "table": {
      "level": "Nível",
      "points": "Pontuação",
      "color": "Cor",
      "reward": "Recompensa"
    },
    "rewardsConfigured_one": "{{count}} recompensa configurada",
    "rewardsConfigured_zero": "{{count}} recompensas configuradas",
    "rewardsConfigured_other": "{{count}} recompensas configuradas",
    "edit": "Editar",
    "delete": "Excluir",
    "deleteConfirm": {
      "title": "Excluir nível",
      "description": "Tem certeza que deseja excluir este nível?",
      "confirm": "Excluir"
    },
    "deleteSuccess": "Nível excluído com sucesso!",
    "deleteError": "Erro ao excluir nível",
    "empty": {
      "title": "Nenhum nível configurado",
      "description": "Comece criando seu primeiro nível",
      "create": "Criar Nível"
    }
  },
  "tasks": {
    "title": "Tarefas em breve",
    "description": "A funcionalidade de tarefas estará disponível em uma futura atualização."
  },
  "explanation": {
    "button": "Explicação aos alunos",
    "dialogTitle": "Explicação aos alunos",
    "dialogDescription": "Este texto será exibido para os alunos na página de ranking, explicando como funciona a gamificação.",
    "placeholder": "Escreva a explicação sobre como funciona a gamificação...",
    "saveSuccess": "Texto de explicação salvo!",
    "saveError": "Erro ao salvar texto",
    "defaultText": "Bem-vindo à gamificação da nossa plataforma!\n\nAqui na nossa comunidade, implementamos um sistema de pontuação para reconhecer e recompensar o envolvimento dos membros. Através dessa gamificação, você terá a oportunidade de ganhar pontos, medalhas, subir de nível e conquistar recompensas incríveis.\n\nAbaixo está a tabela de pontuação que utilizamos:\n\n• Aula concluída: Ao concluir uma aula, você receberá 10 pontos.\n• Curso iniciado: Iniciar um curso também garante 50 pontos para você.\n• Atingir 25% de um curso: Quando você atinge 25% de progresso em um curso, será premiado com 20 pontos.\n• Atingir 50% de um curso: Ao alcançar metade do curso, você ganhará 30 pontos adicionais.\n• Atingir 75% de um curso: Ao atingir 75% de um curso, você será recompensado com 50 pontos.\n• Curso concluído: Concluir um curso inteiro renderá a você 100 pontos.\n• Certificado emitido: Quando você obtiver um certificado, receberá uma bonificação de 100 pontos.\n• Favoritar aula: Favoritar uma aula lhe concederá 5 pontos.\n• Login diário: Apenas fazer login na plataforma já garante 5 pontos.\n• Mensagem publicada: Cada vez que você publicar uma mensagem no fórum ou comunidade, receberá 5 pontos.\n\nEstamos empolgados em apresentar a você os nossos seis níveis de gamificação:\n\n→ Nível 1: Para alcançar o primeiro nível, você precisa acumular 1 ponto.\n→ Nível 2: Para alcançar o segundo nível, você precisa acumular 500 pontos.\n→ Nível 3: Para alcançar o terceiro nível, você precisa acumular 1.000 pontos.\n→ Nível 4: Para alcançar o quarto nível, você precisa acumular 2.000 pontos.\n→ Nível 5: Para alcançar o quinto nível, você precisa acumular 3.000 pontos.\n→ Nível 6: Para alcançar o sexto e último nível, você precisa acumular 4.000 pontos.\n\nFique atento às suas conquistas e ao seu progresso direto no seu perfil, pois nossa comunidade valoriza seu engajamento e quer incentivá-lo a explorar todo o potencial que oferecemos. A gamificação é uma forma divertida e motivadora de se envolver na plataforma, enquanto você aprende, compartilha conhecimentos e se conecta com outros membros apaixonados.\n\nEstamos empolgados para ver você conquistando pontuações altas, avançando pelos níveis e alcançando seus objetivos.\n\nBoa sorte e divirta-se na nossa comunidade gamificada!"
  }
}
